module.exports = __webpack_public_path__ + "static/media/mesh-popup-img2.cb704396.png";